import React from 'react';
import {Header} from './Header';
import {Footer} from './Footer';
import {NavLink} from 'react-router-dom';
import {Helmet} from 'react-helmet';

import article_img01 from '../assets/images/article-sam-and-sofia-steve.jpg';
import article_img02 from '../assets/images/article-roger.jpg';
import article_img03 from '../assets/images/article-amanda-mclaren.jpg';
import article_img04 from '../assets/images/article-christopher-salter.jpg';
import article_img05 from '../assets/images/article-alice-hibbert-davies.jpg';
import {userReviewsIntro as userReviewsIntro_en, whatIsCamAPSFX as whatIsCamAPSFX_en} from "../libs/en/common-text-lib";
import {userReviewsIntro as userReviewsIntro_en_ca, whatIsCamAPSFX as whatIsCamAPSFX_en_ca} from "../libs/en-ca/common-text-lib";
import {userReviewsIntro as userReviewsIntro_de, whatIsCamAPSFX as whatIsCamAPSFX_de} from "../libs/de/common-text-lib";
import {userReviewsIntro as userReviewsIntro_de_ch, whatIsCamAPSFX as whatIsCamAPSFX_de_ch} from "../libs/de-ch/common-text-lib";
import {userReviewsIntro as userReviewsIntro_fr, whatIsCamAPSFX as whatIsCamAPSFX_fr} from "../libs/fr/common-text-lib";
import {userReviewsIntro as userReviewsIntro_fr_ca, whatIsCamAPSFX as whatIsCamAPSFX_fr_ca} from "../libs/fr-ca/common-text-lib";
import {userReviewsIntro as userReviewsIntro_nl, whatIsCamAPSFX as whatIsCamAPSFX_nl} from "../libs/nl/common-text-lib";
import {userReviewsIntro as userReviewsIntro_it, whatIsCamAPSFX as whatIsCamAPSFX_it} from "../libs/it/common-text-lib";
import {userReviewsIntro as userReviewsIntro_it_ch, whatIsCamAPSFX as whatIsCamAPSFX_it_ch} from "../libs/it-ch/common-text-lib";
import {userReviewsIntro as userReviewsIntro_cz, whatIsCamAPSFX as whatIsCamAPSFX_cz} from "../libs/cz/common-text-lib";
import {userReviewsIntro as userReviewsIntro_fi, whatIsCamAPSFX as whatIsCamAPSFX_fi} from "../libs/fi/common-text-lib";
import {userReviewsIntro as userReviewsIntro_pl, whatIsCamAPSFX as whatIsCamAPSFX_pl} from "../libs/pl/common-text-lib";
import {userReviewsIntro as userReviewsIntro_se, whatIsCamAPSFX as whatIsCamAPSFX_se} from "../libs/se/common-text-lib";
import {userReviewsIntro as userReviewsIntro_no, whatIsCamAPSFX as whatIsCamAPSFX_no} from "../libs/no/common-text-lib";
import {userReviewsIntro as userReviewsIntro_dk, whatIsCamAPSFX as whatIsCamAPSFX_dk} from "../libs/dk/common-text-lib";
import {userReviewsIntro as userReviewsIntro_es, whatIsCamAPSFX as whatIsCamAPSFX_es} from "../libs/es/common-text-lib";
import {userReviewsIntro as userReviewsIntro_pt, whatIsCamAPSFX as whatIsCamAPSFX_pt} from "../libs/pt/common-text-lib";

import {samReviewText as samReviewText_en} from "../libs/en/texts-review-messages-lib";
import {samReviewText as samReviewText_en_ca} from "../libs/en-ca/texts-review-messages-lib";
import {samReviewText as samReviewText_de} from "../libs/de/texts-review-messages-lib";
import {samReviewText as samReviewText_fr} from "../libs/fr/texts-review-messages-lib";
import {samReviewText as samReviewText_fr_ca} from "../libs/fr-ca/texts-review-messages-lib";
import {samReviewText as samReviewText_nl} from "../libs/nl/texts-review-messages-lib";
import {samReviewText as samReviewText_it} from "../libs/it/texts-review-messages-lib";
import {samReviewText as samReviewText_cz} from "../libs/cz/texts-review-messages-lib";
import {samReviewText as samReviewText_fi} from "../libs/fi/texts-review-messages-lib";
import {samReviewText as samReviewText_pl} from "../libs/pl/texts-review-messages-lib";
import {samReviewText as samReviewText_se} from "../libs/se/texts-review-messages-lib";
import {samReviewText as samReviewText_no} from "../libs/no/texts-review-messages-lib";
import {samReviewText as samReviewText_dk} from "../libs/dk/texts-review-messages-lib";
import {samReviewText as samReviewText_es} from "../libs/es/texts-review-messages-lib";
import {samReviewText as samReviewText_pt} from "../libs/pt/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_en} from "../libs/en/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_en_ca} from "../libs/en-ca/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_de} from "../libs/de/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_fr} from "../libs/fr/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_fr_ca} from "../libs/fr-ca/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_nl} from "../libs/nl/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_it} from "../libs/it/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_cz} from "../libs/cz/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_fi} from "../libs/fi/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_pl} from "../libs/pl/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_se} from "../libs/se/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_no} from "../libs/no/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_dk} from "../libs/dk/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_es} from "../libs/es/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_pt} from "../libs/pt/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_en} from "../libs/en/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_en_ca} from "../libs/en-ca/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_de} from "../libs/de/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_fr} from "../libs/fr/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_fr_ca} from "../libs/fr-ca/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_nl} from "../libs/nl/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_it} from "../libs/it/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_cz} from "../libs/cz/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_fi} from "../libs/fi/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_pl} from "../libs/pl/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_se} from "../libs/se/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_no} from "../libs/no/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_dk} from "../libs/dk/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_es} from "../libs/es/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_pt} from "../libs/pt/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_en} from "../libs/en/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_en} from "../libs/en/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_en_ca} from "../libs/en-ca/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_en_ca} from "../libs/en-ca/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_de} from "../libs/de/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_de} from "../libs/de/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_fr} from "../libs/fr/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_fr} from "../libs/fr/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_fr_ca} from "../libs/fr-ca/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_fr_ca} from "../libs/fr-ca/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_nl} from "../libs/nl/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_nl} from "../libs/nl/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_it} from "../libs/it/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_it} from "../libs/it/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_cz} from "../libs/cz/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_cz} from "../libs/cz/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_fi} from "../libs/fi/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_fi} from "../libs/fi/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_pl} from "../libs/pl/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_pl} from "../libs/pl/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_se} from "../libs/se/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_se} from "../libs/se/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_no} from "../libs/no/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_no} from "../libs/no/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_dk} from "../libs/dk/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_dk} from "../libs/dk/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_es} from "../libs/es/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_es} from "../libs/es/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_pt} from "../libs/pt/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_pt} from "../libs/pt/texts-review-messages-lib";
import {reviewsPage as reviewsPage_en} from "../libs/en/reviews-page-texts-lib";
import {reviewsPage as reviewsPage_en_ca} from "../libs/en-ca/reviews-page-texts-lib";
import {reviewsPage as reviewsPage_de} from "../libs/de/reviews-page-texts-lib";
import {reviewsPage as reviewsPage_fr} from "../libs/fr/reviews-page-texts-lib";
import {reviewsPage as reviewsPage_fr_ca} from "../libs/fr-ca/reviews-page-texts-lib";
import {reviewsPage as reviewsPage_nl} from "../libs/nl/reviews-page-texts-lib";
import {reviewsPage as reviewsPage_it} from "../libs/it/reviews-page-texts-lib";
import {samReviewText as samReviewText_de_ch} from "../libs/de-ch/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_de_ch} from "../libs/de-ch/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_de_ch} from "../libs/de-ch/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_de_ch} from "../libs/de-ch/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_de_ch} from "../libs/de-ch/texts-review-messages-lib";
import {samReviewText as samReviewText_it_ch} from "../libs/it-ch/texts-review-messages-lib";
import {rogerReviewText as rogerReviewText_it_ch} from "../libs/it-ch/texts-review-messages-lib";
import {amandaReviewText as amandaReviewText_it_ch} from "../libs/it-ch/texts-review-messages-lib";
import {christopherReviewText as christopherReviewText_it_ch} from "../libs/it-ch/texts-review-messages-lib";
import {aliceReviewText as aliceReviewText_it_ch} from "../libs/it-ch/texts-review-messages-lib";
import {reviewsPage as reviewsPage_de_ch} from "../libs/de-ch/reviews-page-texts-lib";
import {reviewsPage as reviewsPage_it_ch} from "../libs/it-ch/reviews-page-texts-lib";
import {reviewsPage as reviewsPage_cz} from "../libs/cz/reviews-page-texts-lib";
import {reviewsPage as reviewsPage_fi} from "../libs/fi/reviews-page-texts-lib";
import {reviewsPage as reviewsPage_pl} from "../libs/pl/reviews-page-texts-lib";
import {reviewsPage as reviewsPage_se} from "../libs/se/reviews-page-texts-lib";
import {reviewsPage as reviewsPage_no} from "../libs/no/reviews-page-texts-lib";
import {reviewsPage as reviewsPage_dk} from "../libs/dk/reviews-page-texts-lib";
import {reviewsPage as reviewsPage_es} from "../libs/es/reviews-page-texts-lib";
import {reviewsPage as reviewsPage_pt} from "../libs/pt/reviews-page-texts-lib";

import parse from "html-react-parser";

class Reviews extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            language: this.props.language,
            samReviewText: samReviewText_en,
            rogerReviewText: rogerReviewText_en,
            amandaReviewText: amandaReviewText_en,
            christopherReviewText: christopherReviewText_en,
            aliceReviewText: aliceReviewText_en,
            whatIsCamAPSFX: whatIsCamAPSFX_en,
            userReviewsIntro: userReviewsIntro_en,
            reviewsPage: reviewsPage_en,
            prefix: ''
        };

        // set localisation text
        if (this.props.language === "DE") {
            this.state.samReviewText = samReviewText_de;
            this.state.rogerReviewText = rogerReviewText_de;
            this.state.amandaReviewText = amandaReviewText_de;
            this.state.christopherReviewText = christopherReviewText_de;
            this.state.aliceReviewText = aliceReviewText_de;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_de;
            this.state.userReviewsIntro = userReviewsIntro_de;
            this.state.reviewsPage = reviewsPage_de;
            this.state.prefix = '/de';
        }
        if (this.props.language === "DE-CH") {
            this.state.samReviewText = samReviewText_de_ch;
            this.state.rogerReviewText = rogerReviewText_de_ch;
            this.state.amandaReviewText = amandaReviewText_de_ch;
            this.state.christopherReviewText = christopherReviewText_de_ch;
            this.state.aliceReviewText = aliceReviewText_de_ch;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_de_ch;
            this.state.userReviewsIntro = userReviewsIntro_de_ch;
            this.state.reviewsPage = reviewsPage_de_ch;
            this.state.prefix = '/de-ch';
        }

        if (this.props.language === "EN-CA") {
            this.state.samReviewText = samReviewText_en_ca;
            this.state.rogerReviewText = rogerReviewText_en_ca;
            this.state.amandaReviewText = amandaReviewText_en_ca;
            this.state.christopherReviewText = christopherReviewText_en_ca;
            this.state.aliceReviewText = aliceReviewText_en_ca;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_en_ca;
            this.state.userReviewsIntro = userReviewsIntro_en_ca;
            this.state.reviewsPage = reviewsPage_en_ca;
            this.state.prefix = '/en-ca';
        }

        if (this.props.language === "FR") {
            this.state.samReviewText = samReviewText_fr;
            this.state.rogerReviewText = rogerReviewText_fr;
            this.state.amandaReviewText = amandaReviewText_fr;
            this.state.christopherReviewText = christopherReviewText_fr;
            this.state.aliceReviewText = aliceReviewText_fr;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_fr;
            this.state.userReviewsIntro = userReviewsIntro_fr;
            this.state.reviewsPage = reviewsPage_fr;
            this.state.prefix = '/fr-ch';
        }

        if (this.props.language === "FR-CA") {
            this.state.samReviewText = samReviewText_fr_ca;
            this.state.rogerReviewText = rogerReviewText_fr_ca;
            this.state.amandaReviewText = amandaReviewText_fr_ca;
            this.state.christopherReviewText = christopherReviewText_fr_ca;
            this.state.aliceReviewText = aliceReviewText_fr_ca;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_fr_ca;
            this.state.userReviewsIntro = userReviewsIntro_fr_ca;
            this.state.reviewsPage = reviewsPage_fr_ca;
            this.state.prefix = '/fr-ca';
        }

        if (this.props.language === "FR-FR") {
            this.state.samReviewText = samReviewText_fr;
            this.state.rogerReviewText = rogerReviewText_fr;
            this.state.amandaReviewText = amandaReviewText_fr;
            this.state.christopherReviewText = christopherReviewText_fr;
            this.state.aliceReviewText = aliceReviewText_fr;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_fr;
            this.state.userReviewsIntro = userReviewsIntro_fr;
            this.state.reviewsPage = reviewsPage_fr;
            this.state.prefix = '/fr';
        }

        if (this.props.language === "NL") {
            this.state.samReviewText = samReviewText_nl;
            this.state.rogerReviewText = rogerReviewText_nl;
            this.state.amandaReviewText = amandaReviewText_nl;
            this.state.christopherReviewText = christopherReviewText_nl;
            this.state.aliceReviewText = aliceReviewText_nl;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_nl;
            this.state.userReviewsIntro = userReviewsIntro_nl;
            this.state.reviewsPage = reviewsPage_nl;
            this.state.prefix = '/nl';
        }
        if (this.props.language === "IT") {
            this.state.samReviewText = samReviewText_it;
            this.state.rogerReviewText = rogerReviewText_it;
            this.state.amandaReviewText = amandaReviewText_it;
            this.state.christopherReviewText = christopherReviewText_it;
            this.state.aliceReviewText = aliceReviewText_it;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_it;
            this.state.userReviewsIntro = userReviewsIntro_it;
            this.state.reviewsPage = reviewsPage_it;
            this.state.prefix = '/it';
        }
        if (this.props.language === "IT-CH") {
            this.state.samReviewText = samReviewText_it_ch;
            this.state.rogerReviewText = rogerReviewText_it_ch;
            this.state.amandaReviewText = amandaReviewText_it_ch;
            this.state.christopherReviewText = christopherReviewText_it_ch;
            this.state.aliceReviewText = aliceReviewText_it_ch;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_it_ch;
            this.state.userReviewsIntro = userReviewsIntro_it_ch;
            this.state.reviewsPage = reviewsPage_it_ch;
            this.state.prefix = '/it-ch';
        }
        if (this.props.language === "CZ") {
            this.state.samReviewText = samReviewText_cz;
            this.state.rogerReviewText = rogerReviewText_cz;
            this.state.amandaReviewText = amandaReviewText_cz;
            this.state.christopherReviewText = christopherReviewText_cz;
            this.state.aliceReviewText = aliceReviewText_cz;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_cz;
            this.state.userReviewsIntro = userReviewsIntro_cz;
            this.state.reviewsPage = reviewsPage_cz;
            this.state.prefix = '/cz';
        }
        if (this.props.language === "FI") {
            this.state.samReviewText = samReviewText_fi;
            this.state.rogerReviewText = rogerReviewText_fi;
            this.state.amandaReviewText = amandaReviewText_fi;
            this.state.christopherReviewText = christopherReviewText_fi;
            this.state.aliceReviewText = aliceReviewText_fi;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_fi;
            this.state.userReviewsIntro = userReviewsIntro_fi;
            this.state.reviewsPage = reviewsPage_fi;
            this.state.prefix = '/fi';
        }
        if (this.props.language === "PL") {
            this.state.samReviewText = samReviewText_pl;
            this.state.rogerReviewText = rogerReviewText_pl;
            this.state.amandaReviewText = amandaReviewText_pl;
            this.state.christopherReviewText = christopherReviewText_pl;
            this.state.aliceReviewText = aliceReviewText_pl;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_pl;
            this.state.userReviewsIntro = userReviewsIntro_pl;
            this.state.reviewsPage = reviewsPage_pl;
            this.state.prefix = '/pl';
        }
        if (this.props.language === "SE") {
            this.state.samReviewText = samReviewText_se;
            this.state.rogerReviewText = rogerReviewText_se;
            this.state.amandaReviewText = amandaReviewText_se;
            this.state.christopherReviewText = christopherReviewText_se;
            this.state.aliceReviewText = aliceReviewText_se;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_se;
            this.state.userReviewsIntro = userReviewsIntro_se;
            this.state.reviewsPage = reviewsPage_se;
            this.state.prefix = '/se';
        }
        if (this.props.language === "NO") {
            this.state.samReviewText = samReviewText_no;
            this.state.rogerReviewText = rogerReviewText_no;
            this.state.amandaReviewText = amandaReviewText_no;
            this.state.christopherReviewText = christopherReviewText_no;
            this.state.aliceReviewText = aliceReviewText_no;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_no;
            this.state.userReviewsIntro = userReviewsIntro_no;
            this.state.reviewsPage = reviewsPage_no;
            this.state.prefix = '/nb';
        }
        if (this.props.language === "DK") {
            this.state.samReviewText = samReviewText_dk;
            this.state.rogerReviewText = rogerReviewText_dk;
            this.state.amandaReviewText = amandaReviewText_dk;
            this.state.christopherReviewText = christopherReviewText_dk;
            this.state.aliceReviewText = aliceReviewText_dk;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_dk;
            this.state.userReviewsIntro = userReviewsIntro_dk;
            this.state.reviewsPage = reviewsPage_dk;
            this.state.prefix = '/dk';
        }
        if (this.props.language === "ES") {
            this.state.samReviewText = samReviewText_es;
            this.state.rogerReviewText = rogerReviewText_es;
            this.state.amandaReviewText = amandaReviewText_es;
            this.state.christopherReviewText = christopherReviewText_es;
            this.state.aliceReviewText = aliceReviewText_es;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_es;
            this.state.userReviewsIntro = userReviewsIntro_es;
            this.state.reviewsPage = reviewsPage_es;
            this.state.prefix = '/es';
        }
        if (this.props.language === "PT") {
            this.state.samReviewText = samReviewText_pt;
            this.state.rogerReviewText = rogerReviewText_pt;
            this.state.amandaReviewText = amandaReviewText_pt;
            this.state.christopherReviewText = christopherReviewText_pt;
            this.state.aliceReviewText = aliceReviewText_pt;
            this.state.whatIsCamAPSFX = whatIsCamAPSFX_pt;
            this.state.userReviewsIntro = userReviewsIntro_pt;
            this.state.reviewsPage = reviewsPage_pt;
            this.state.prefix = '/pt';
        }
    }

    /**
     * Sets localisation text
     * */
    setLanguageVars() {
        if (this.state.language !== this.props.language) {
            if (this.props.language === "EN") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_en,
                    rogerReviewText: rogerReviewText_en,
                    amandaReviewText: amandaReviewText_en,
                    christopherReviewText: christopherReviewText_en,
                    aliceReviewText: aliceReviewText_en,
                    whatIsCamAPSFX: whatIsCamAPSFX_en,
                    userReviewsIntro: userReviewsIntro_en,
                    reviewsPage: reviewsPage_en,
                    prefix: ''
                });
            }

            // set localisation text
            if (this.props.language === "DE") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_de,
                    rogerReviewText: rogerReviewText_de,
                    amandaReviewText: amandaReviewText_de,
                    christopherReviewText: christopherReviewText_de,
                    aliceReviewText: aliceReviewText_de,
                    whatIsCamAPSFX: whatIsCamAPSFX_de,
                    userReviewsIntro: userReviewsIntro_de,
                    reviewsPage: reviewsPage_de,
                    prefix: '/de'
                });
            }
            if (this.props.language === "DE-CH") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_de_ch,
                    rogerReviewText: rogerReviewText_de_ch,
                    amandaReviewText: amandaReviewText_de_ch,
                    christopherReviewText: christopherReviewText_de_ch,
                    aliceReviewText: aliceReviewText_de_ch,
                    whatIsCamAPSFX: whatIsCamAPSFX_de_ch,
                    userReviewsIntro: userReviewsIntro_de_ch,
                    reviewsPage: reviewsPage_de_ch,
                    prefix: '/de-ch'
                });
            }

            if (this.props.language === "EN-CA") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_en_ca,
                    rogerReviewText: rogerReviewText_en_ca,
                    amandaReviewText: amandaReviewText_en_ca,
                    christopherReviewText: christopherReviewText_en_ca,
                    aliceReviewText: aliceReviewText_en_ca,
                    whatIsCamAPSFX: whatIsCamAPSFX_en_ca,
                    userReviewsIntro: userReviewsIntro_en_ca,
                    reviewsPage: reviewsPage_en_ca,
                    prefix: '/en-ca'
                });
            }

            if (this.props.language === "FR") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_fr,
                    rogerReviewText: rogerReviewText_fr,
                    amandaReviewText: amandaReviewText_fr,
                    christopherReviewText: christopherReviewText_fr,
                    aliceReviewText: aliceReviewText_fr,
                    whatIsCamAPSFX: whatIsCamAPSFX_fr,
                    userReviewsIntro: userReviewsIntro_fr,
                    reviewsPage: reviewsPage_fr,
                    prefix: '/fr-ch'
                });
            }

            if (this.props.language === "FR-CA") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_fr_ca,
                    rogerReviewText: rogerReviewText_fr_ca,
                    amandaReviewText: amandaReviewText_fr_ca,
                    christopherReviewText: christopherReviewText_fr_ca,
                    aliceReviewText: aliceReviewText_fr_ca,
                    whatIsCamAPSFX: whatIsCamAPSFX_fr_ca,
                    userReviewsIntro: userReviewsIntro_fr_ca,
                    reviewsPage: reviewsPage_fr_ca,
                    prefix: '/fr-ca'
                });
            }

            if (this.props.language === "FR-FR") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_fr,
                    rogerReviewText: rogerReviewText_fr,
                    amandaReviewText: amandaReviewText_fr,
                    christopherReviewText: christopherReviewText_fr,
                    aliceReviewText: aliceReviewText_fr,
                    whatIsCamAPSFX: whatIsCamAPSFX_fr,
                    userReviewsIntro: userReviewsIntro_fr,
                    reviewsPage: reviewsPage_fr,
                    prefix: '/fr'
                });
            }

            if (this.props.language === "NL") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_nl,
                    rogerReviewText: rogerReviewText_nl,
                    amandaReviewText: amandaReviewText_nl,
                    christopherReviewText: christopherReviewText_nl,
                    aliceReviewText: aliceReviewText_nl,
                    whatIsCamAPSFX: whatIsCamAPSFX_nl,
                    userReviewsIntro: userReviewsIntro_nl,
                    reviewsPage: reviewsPage_nl,
                    prefix: '/nl'
                });
            }
            if (this.props.language === "IT") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_it,
                    rogerReviewText: rogerReviewText_it,
                    amandaReviewText: amandaReviewText_it,
                    christopherReviewText: christopherReviewText_it,
                    aliceReviewText: aliceReviewText_it,
                    whatIsCamAPSFX: whatIsCamAPSFX_it,
                    userReviewsIntro: userReviewsIntro_it,
                    reviewsPage: reviewsPage_it,
                    prefix: '/it'
                });
            }
            if (this.props.language === "IT-CH") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_it_ch,
                    rogerReviewText: rogerReviewText_it_ch,
                    amandaReviewText: amandaReviewText_it_ch,
                    christopherReviewText: christopherReviewText_it_ch,
                    aliceReviewText: aliceReviewText_it_ch,
                    whatIsCamAPSFX: whatIsCamAPSFX_it_ch,
                    userReviewsIntro: userReviewsIntro_it_ch,
                    reviewsPage: reviewsPage_it_ch,
                    prefix: '/it-ch'
                });
            }
            if (this.props.language === "CZ") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_cz,
                    rogerReviewText: rogerReviewText_cz,
                    amandaReviewText: amandaReviewText_cz,
                    christopherReviewText: christopherReviewText_cz,
                    aliceReviewText: aliceReviewText_cz,
                    whatIsCamAPSFX: whatIsCamAPSFX_cz,
                    userReviewsIntro: userReviewsIntro_cz,
                    reviewsPage: reviewsPage_cz,
                    prefix: '/cz'
                });
            }
            if (this.props.language === "FI") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_fi,
                    rogerReviewText: rogerReviewText_fi,
                    amandaReviewText: amandaReviewText_fi,
                    christopherReviewText: christopherReviewText_fi,
                    aliceReviewText: aliceReviewText_fi,
                    whatIsCamAPSFX: whatIsCamAPSFX_fi,
                    userReviewsIntro: userReviewsIntro_fi,
                    reviewsPage: reviewsPage_fi,
                    prefix: '/fi'
                });
            }
            if (this.props.language === "PL") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_pl,
                    rogerReviewText: rogerReviewText_pl,
                    amandaReviewText: amandaReviewText_pl,
                    christopherReviewText: christopherReviewText_pl,
                    aliceReviewText: aliceReviewText_pl,
                    whatIsCamAPSFX: whatIsCamAPSFX_pl,
                    userReviewsIntro: userReviewsIntro_pl,
                    reviewsPage: reviewsPage_pl,
                    prefix: '/pl'
                });
            }
            if (this.props.language === "SE") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_se,
                    rogerReviewText: rogerReviewText_se,
                    amandaReviewText: amandaReviewText_se,
                    christopherReviewText: christopherReviewText_se,
                    aliceReviewText: aliceReviewText_se,
                    whatIsCamAPSFX: whatIsCamAPSFX_se,
                    userReviewsIntro: userReviewsIntro_se,
                    reviewsPage: reviewsPage_se,
                    prefix: '/se'
                });
            }
            if (this.props.language === "NO") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_no,
                    rogerReviewText: rogerReviewText_no,
                    amandaReviewText: amandaReviewText_no,
                    christopherReviewText: christopherReviewText_no,
                    aliceReviewText: aliceReviewText_no,
                    whatIsCamAPSFX: whatIsCamAPSFX_no,
                    userReviewsIntro: userReviewsIntro_no,
                    reviewsPage: reviewsPage_no,
                    prefix: '/nb'
                });
            }
            if (this.props.language === "DK") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_dk,
                    rogerReviewText: rogerReviewText_dk,
                    amandaReviewText: amandaReviewText_dk,
                    christopherReviewText: christopherReviewText_dk,
                    aliceReviewText: aliceReviewText_dk,
                    whatIsCamAPSFX: whatIsCamAPSFX_dk,
                    userReviewsIntro: userReviewsIntro_dk,
                    reviewsPage: reviewsPage_dk,
                    prefix: '/dk'
                });
            }
            if (this.props.language === "ES") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_es,
                    rogerReviewText: rogerReviewText_es,
                    amandaReviewText: amandaReviewText_es,
                    christopherReviewText: christopherReviewText_es,
                    aliceReviewText: aliceReviewText_es,
                    whatIsCamAPSFX: whatIsCamAPSFX_es,
                    userReviewsIntro: userReviewsIntro_es,
                    reviewsPage: reviewsPage_es,
                    prefix: '/es'
                });
            }
            if (this.props.language === "PT") {
                this.setState({
                    language: this.props.language,
                    samReviewText: samReviewText_pt,
                    rogerReviewText: rogerReviewText_pt,
                    amandaReviewText: amandaReviewText_pt,
                    christopherReviewText: christopherReviewText_pt,
                    aliceReviewText: aliceReviewText_pt,
                    whatIsCamAPSFX: whatIsCamAPSFX_pt,
                    userReviewsIntro: userReviewsIntro_pt,
                    reviewsPage: reviewsPage_pt,
                    prefix: '/pt'
                });
            }
        }
    }

    componentDidUpdate() {
        this.setLanguageVars();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>{parse(this.state.reviewsPage.title)}</title>
                    <meta name="title" content={parse(this.state.reviewsPage.titleMeta)}/>
                    <meta name="description"
                          content={parse(this.state.reviewsPage.descriptionMeta)}/>
                    <meta property="og:locale" content={this.state.reviewsPage.localeMeta}/>
                    <meta name="keywords" content={this.state.reviewsPage.keywords}/>
                </Helmet>
                <Header props={this.props}/>
                <section className='inner-banner inner-banner user-training-page'>
                    <div className='container'>
                        <div className='user-training-header animations-page-header'>
                            <h1>{parse(this.state.userReviewsIntro.header)}</h1>
                            <p>{parse(this.state.userReviewsIntro.text)}</p>
                        </div>
                    </div>
                </section>
                <section className='review-page'>
                    <div className='container'>
                        <div className='rv-card'>
                            <div className='rv-card-line'></div>
                            <div className='rv-card-content'>
                                <span
                                    className='rv-card-avatar'
                                    style={{backgroundImage: `url(${article_img05})`}}
                                ></span>
                                <div className='rv-card-body'>
                                    <p className='rv-card-name'>{this.state.aliceReviewText.imageTitle}</p>
                                    {parse(this.state.aliceReviewText.shortIntroAndBody)}
                                    <NavLink
                                        to={this.state.prefix + '/stories/alice-hibbert-davies'}
                                        className='rv-card-readmore'>
                                        {parse(this.state.userReviewsIntro.readMore)}
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                        <div className='rv-card'>
                            <div className='rv-card-line'></div>
                            <div className='rv-card-content'>
                                <span
                                    className='rv-card-avatar'
                                    style={{backgroundImage: `url(${article_img04})`}}
                                ></span>
                                <div className='rv-card-body'>
                                    <p className='rv-card-name'>{this.state.christopherReviewText.imageTitle}</p>
                                    {parse(this.state.christopherReviewText.shortIntroAndBody)}
                                    <NavLink
                                        to={this.state.prefix + '/stories/christopher-salter'}
                                        className='rv-card-readmore'>
                                        {parse(this.state.userReviewsIntro.readMore)}
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                        <div className='rv-card'>
                            <div className='rv-card-line'></div>
                            <div className='rv-card-content'>
                                <span
                                    className='rv-card-avatar'
                                    style={{backgroundImage: `url(${article_img03})`}}
                                ></span>
                                <div className='rv-card-body'>
                                    <p className='rv-card-name'>{this.state.amandaReviewText.imageTitle}</p>
                                    {parse(this.state.amandaReviewText.shortIntroAndBody)}
                                    <NavLink
                                        to={this.state.prefix + '/stories/amanda-mclaren'}
                                        className='rv-card-readmore'>
                                        {parse(this.state.userReviewsIntro.readMore)}
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                        <div className='rv-card'>
                            <div className='rv-card-line'></div>
                            <div className='rv-card-content'>
                                <span
                                    className='rv-card-avatar'
                                    style={{backgroundImage: `url(${article_img02})`}}
                                ></span>
                                <div className='rv-card-body'>
                                    <p className='rv-card-name'>{this.state.rogerReviewText.imageTitle}</p>
                                    {parse(this.state.rogerReviewText.shortIntroAndBody)}
                                    <NavLink
                                        to={this.state.prefix + '/stories/roger'}
                                        className='rv-card-readmore'>
                                        {parse(this.state.userReviewsIntro.readMore)}
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                        <div className='rv-card'>
                            <div className='rv-card-line'></div>
                            <div className='rv-card-content'>
                                <span
                                    className='rv-card-avatar'
                                    style={{backgroundImage: `url(${article_img01})`}}
                                ></span>
                                <div className='rv-card-body'>
                                    <p className='rv-card-name'>{this.state.samReviewText.imageTitle}</p>
                                    {parse(this.state.samReviewText.shortIntroAndBody)}
                                    <NavLink
                                        to={this.state.prefix + '/stories/sam-and-sofia-stevie'}
                                        className='rv-card-readmore'>
                                        {parse(this.state.userReviewsIntro.readMore)}
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <section className='content-sec'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 col-sm-12'>
                                <div className='content-inner'>
                                    {parse(this.state.whatIsCamAPSFX.body)}
                                    <Link to={this.state.prefix + '/faq'}
                                          className='btn'>
                                        {parse(this.state.whatIsCamAPSFX.linkFindOutMore)}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
                <Footer props={this.props}/>
            </div>
        );
    }
}

export default Reviews;
